export function useCountdown({ key, count }: { key: string, count: number }) {
  const timerValue = useCookie(key, {
    default: () => '900',
    maxAge: 9000,
  });
  const timerCount = ref(count || Number(timerValue.value));

  const minutes = computed(() => {
    return Math.floor(timerCount.value / 60)
      .toString()
      .padStart(2, '0');
  });
  const seconds = computed(() => (timerCount.value % 60).toString().padStart(2, '0'));
  const timer = computed(() => `${minutes.value}:${seconds.value}`);
  let intervalId: NodeJS.Timeout;

  const startTimer = (customTimer?: number): void => {
    if (intervalId) {
      stopTimer();
    }

    if (customTimer !== undefined) {
      timerCount.value = customTimer;
    }

    if (Number(timerCount.value)) {
      intervalId = setInterval(() => {
        timerCount.value--;

        if (timerCount.value <= 0) {
          stopTimer();
        }
      }, 1000);
    }
  };

  const stopTimer = () => {
    clearInterval(intervalId);
  };

  const saveTimer = (value: string) => {
    timerValue.value = value;
  };

  onBeforeUnmount(stopTimer);

  return {
    timer,
    timerCount,
    stopTimer,
    startTimer,
    saveTimer,
    minutes,
    seconds,
  };
}
